import { render, staticRenderFns } from "./classItem.vue?vue&type=template&id=48ac8ca5&scoped=true&"
import script from "./classItem.vue?vue&type=script&lang=js&"
export * from "./classItem.vue?vue&type=script&lang=js&"
import style0 from "./classItem.vue?vue&type=style&index=0&id=48ac8ca5&scoped=true&lang=css&"
import style1 from "./classItem.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ac8ca5",
  null
  
)

export default component.exports